<template>
  <div class="slider" data-in-out data-in-out-animation="slider-background">
    <SliderBackground />

    <div
      class="slide"
      v-for="(slide, index) in slides"
      :class="{
        'slide--current': $store.state.slider.current === index,
        'slide--prev': (
          $store.state.slider.current - index === 1
          || $store.state.slider.current - index === -3
        ),
        'slide--next': (
          $store.state.slider.current - index === -1
          || $store.state.slider.current - index === 3
        ),
        'slide--empty': (
          $store.state.slider.current - index === 2
          || $store.state.slider.current - index === -2
        ),
      }"
      :key="index"
      :data-slide="slide.path"
    >
      <div
        class="slide__block"
        @click="enterPage"
        :data-slide-key="index"
      >
        <div class="slide__text">
          <p v-html="slide.text"></p>
        </div>
        <div class="slide__title" data-apollo-hover data-apollo-hover-animation="scale">
          <h2 v-html="slides[index].name"></h2>
        </div>
        <div class="slide__discover" @click="enterPage" :data-slide-key="index">
          <div class="slide__discover-label">
            <span>Discover</span>
          </div>
          <div class="slide__discover-icon">
            <div class="slide__discover-icon-arrow"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="slider__footer">
      <div
        class="slider__discover"
        @click="enterPage"
        data-apollo-hover
        data-apollo-hover-animation="scale"
      >
        <span>Discover</span>
        <div class="slider__discover-line"></div>
      </div>
      <div class="slider__controls">
        <div
          class="slider__control slider__control--prev"
          @click="prevSlide"
          data-apollo-hover
          data-apollo-hover-animation="opacity"
        >
          <div class="slider__control-icon">
            <ArrowBall />
          </div>
          <span>Previous</span>
        </div>
        <div
          class="slider__control slider__control--next"
          @click="nextSlide"
          data-apollo-hover
          data-apollo-hover-animation="opacity"
        >
          <span>Next</span>
          <div class="slider__control-icon">
            <ArrowBall />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs';
import SliderBackground from '@/components/slider/SliderBackground.vue';
import ArrowBall from '@/components/ArrowBall.vue';
import animations from '@/assets/animations';
import { isTouchDevice } from '../../scripts/utils';

export default {
  name: 'MainSlider',

  components: {
    SliderBackground,
    ArrowBall,
  },

  data() {
    return {
      slides: [
        {
          name: 'Live.',
          path: 'live',
          url: 'live',
          text: 'Our Manifesto.<br>How we approach the world.<br>To put it simply, how we Live.',
        },
        {
          name: 'Your.',
          path: 'your',
          url: 'moment',
          text: 'Our People, your Prosecco.<br>Friends, Family, Strangers.<br>All are invited.',
        },
        {
          name: 'Moment.',
          path: 'moment',
          url: 'moment',
          text: 'To shape unforgettable moments in everyday situations. Prosecco is only<br>as valuable as the moments it heightens.',
        },
        {
          name: 'Prosecco.',
          path: 'prosecco',
          url: 'collection/cuvee-1821',
          text: 'At home and when partying<br>Eccentric fine bubbles<br>That are now a globally recognized icon.',
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      document.addEventListener('wheel', this.wheelHandler);
      document.body.addEventListener('keydown', this.keyPressHandler);

      if (isTouchDevice) {
        const hm = new Hammer(this.$el);
        hm.on('swipeleft', this.nextSlide);
        hm.on('swiperight', this.prevSlide);
      }
    });
  },

  methods: {
    prevSlide() {
      if (this.$store.state.isSliding) return;
      this.$store.commit('SET_SLIDING', true);
      this.$store.commit('PREV_SLIDE');
      this.$nextTick(() => {
        animations.get('slide-prev')(this.$el).eventCallback('onComplete', () => {
          this.$store.commit('SET_SLIDING', false);
        }).play();
      });
    },
    nextSlide() {
      if (this.$store.state.isSliding) return;
      this.$store.commit('SET_SLIDING', true);
      this.$store.commit('NEXT_SLIDE');
      this.$nextTick(() => {
        animations.get('slide-next')(this.$el).eventCallback('onComplete', () => {
          this.$store.commit('SET_SLIDING', false);
        }).play();
      });
    },
    enterPage(event) {
      if (this.$store.state.isSliding) return;
      if (
        this.$store.state.slider.current === parseInt(event.currentTarget.dataset.slideKey, 10)
        || event.currentTarget.classList.contains('slider__discover')
      ) {
        this.$router.push({
          path: `/${this.$store.state.lang}/${this.slides[this.$store.state.slider.current].url}`,
        });
      } else {
        this.nextSlide();
      }
    },
    wheelHandler(event) {
      if (!this.$store.state.load) return;
      if (event.deltaY < 0) this.prevSlide();
      else this.nextSlide();
    },
    keyPressHandler(event) {
      if (event.keyCode === 37 || event.keyCode === 40) this.prevSlide();
      if (event.keyCode === 38 || event.keyCode === 39) this.nextSlide();
    },
  },
};
</script>

<style lang="scss" scoped>
.slider {
  @extend %full-fixed;
}

.slide {
  @extend %full;
  display: grid;
  @extend %grid-horizontal;
  @extend %grid-vertical;

  &__block {
    grid-column-start: 8;
    grid-column-end: 28;
    grid-row-start: 6;
    grid-row-end: 15;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    transition: opacity 0.5s $inOutQuad;

    @include mq($until: ipadL) {
      grid-column-start: 5;
      grid-row-start: 6;
    }
  }

  &.slide--current .slide__block {
    cursor: pointer;
  }

  &.slide--next .slide__block {
    opacity: 0.4;
  }

  &.slide--next:hover .slide__block {
    cursor: pointer;
    opacity: 1;
  }

  &.slide[data-slide="live"].slide--next {
    z-index: 99; // Fix for last
  }

  &__title {
    opacity: 0;

    h2 {
      font-weight: 300;
      font-size: rem(250px);
      font-size: calc(250px * var(--rw));
      line-height: rem(250px);
      line-height: calc(250px * var(--rw));

      @include mq($until: ipadL) {
        font-size: rem(120px);
        font-size: calc(120px * var(--rw));
        line-height: rem(140px);
        line-height: calc(140px * var(--rw));
      }

      @include mq($until: ipadP) {
        font-size: rem(80px);
        font-size: calc(80px * var(--rw));
        line-height: rem(80px);
        line-height: calc(80px * var(--rw));
      }
    }
  }

  &__text {
    width: calc((100vw / 32) * 7);

    @include mq($until: ipadL) {
      width: 100%;
    }

    p {
      margin: 0px;
      font-weight: normal;
      font-size: rem(22px);
      font-size: $font-size-text;
      line-height: rem(34px);
      line-height: calc(34px * var(--rw));
    }
  }

  &__discover {
    display: none;
    align-items: center;

    @include mq($until: ipadL) {
      display: flex;
    }

    &-label {
      font-size: $font-size-text;
      margin-right: calc((100vw / 32) * 2);
    }

    &-icon {
      width: calc(70px * var(--rw));
      height: calc(70px * var(--rw));
      border-radius: 100%;
      border: 1px solid rgba($color: $color-white, $alpha: 0.6);

      display: flex;
      align-items: center;
      justify-content: center;

      &-arrow {
        width: 20px;
        height: 20px;
        background-image: url('/static/vector/arrow.svg');
        transform: rotate(90deg);
      }
    }
  }
}

.slider__footer {
  position: absolute;
  width: calc(100% - ((100vw / 32) * 3));
  bottom: 0px;
  left: calc((100vw / 32) * 7);
  padding-bottom: calc((100vh / 18) * 1);

  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  @include mq($until: ipadL) {
    padding-top: calc((100vw / 18) * 1);
    width: calc(100% - ((100vw / 32) * 8));
    left: calc((100vw / 32) * 4);
    border-top: 1px solid rgba($color: $color-white, $alpha: 0.6);
  }
}

.slider__discover {
  font-size: rem(22px);
  font-size: $font-size-text;
  cursor: pointer;

  @include mq($until: ipadL) {
    display: none;
  }

  &:hover .slider__discover-line {
    transform: scaleX(1);
  }

  &-line {
    width: 100px;
    height: 1px;
    background-color: $color-white;
    display: inline-block;
    margin-left: calc((100vw /  32) * 1);
    opacity: 0.6;
    transform: scaleX(0.5);
    transform-origin: 0px 50%;
    transition: transform .6s $inOutCubic;
  }
}

.slider__controls {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-right: calc((100vw / 32) * 8);

  @include mq($until: ipadL) {
    margin-right: auto;
    width: 100%;
  }

  .slider__control {
    font-size: rem(22px);
    font-size: $font-size-text;
    cursor: pointer;

    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    &:nth-child(1) {
      ::v-deep .arrow-rotation {
        transform: rotate(-180deg);
      }
    }

    &:nth-child(2) {
      margin-left: calc((100vw / 32) * 2);
    }

    &-icon {
      width: calc((100vw / 32) * 1);
      height: calc((100vw / 32) * 1);
      margin-left: 10px;
      margin-right: 10px;
      transform: translateY(25%);

      @include mq($until: ipadL) {
        display: none;
      }
    }

    &::v-deep svg circle {
      transform-origin: 50% 50%;
    }

    &:hover ::v-deep svg circle {
      transform: scale(1);

      &.fill {
        stroke-dashoffset: 0;
        transition: transform .3s $inOutCubic,
                    stroke-dashoffset .3s $inOutCubic .2s;
      }
    }

    &:hover ::v-deep .arrow {
      transition: opacity .3s $inOutCubic .2s;
      opacity: 1;

      .arrow-animation {
        animation-name: arrow-loop;
        animation-duration: .8s;
        animation-delay: .3s;
        animation-iteration-count: 1;
        animation-timing-function: $inOutCubic;
      }
    }
  }
}
</style>
